// Formの子コンポーネントで実行する
// Form側でバリデーションを実行可能にする
export default function () {
    // 親のFormコンポーネントを取得する
    const form = inject<any>('form')

    // コンポーネントの現在のインスタンスを親のFormに登録する
    const instance = getCurrentInstance();
    form.exposed.register(instance);

    // 該当のコンポーネントがアンマウントされるとき、Formから登録を解除する
    onBeforeUnmount(() => {
        form.exposed.unregister(instance);
    })
}
